document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;

  if (!body.classList.contains("withPortalUpdateBanner")) return;

  const banner = document.querySelector(".c-portalUpdateBanner");
  const header = document.querySelector(".c-mainHeader");

  if (!banner || !header) return;

  let ticking = false;

  function onScroll() {
    const currentScroll = window.scrollY;

    if (currentScroll > 10) {
      banner.classList.add("c-portalUpdateBanner--hidden");
      header.classList.add("c-mainHeader--pinned");
    } else {
      banner.classList.remove("c-portalUpdateBanner--hidden");
      header.classList.remove("c-mainHeader--pinned");
    }

    ticking = false;
  }

  window.addEventListener("scroll", function () {
    if (!ticking) {
      window.requestAnimationFrame(onScroll);
      ticking = true;
    }
  });
});
